import type { NodeDefinition } from '../../../types/node-definition';

const definition: NodeDefinition = {
  type: 'MsSQL',
  name: 'Microsoft SQL Server',
  category: 'database',
  description: 'Execute SQL queries and manage tables on Microsoft SQL Server databases',
  icon: 'sql-server',
  iconType: 'microsoft-icon',
  color: 'indigo',
  version: '1.0.0',
  comingSoon: false,
  credentials: [
    {
      name: 'msSqlCredential',
      required: true,
      displayName: 'MS SQL Server',
    },
  ],
  inputs: [
    {
      name: 'default',
      type: 'main',
      displayName: 'Input',
      required: true,
    },
  ],
  outputs: [
    {
      name: 'default',
      type: 'main',
      displayName: 'Output',
    },
  ],
  
  // Tool-capable configuration for AI Agent
  toolCapable: {
    enabled: true,
    name: 'ms_sql_database',
    description: 'Execute SQL queries and operations on Microsoft SQL Server databases. Supports SELECT, INSERT, UPDATE, DELETE, bulk operations, and table management (create, drop, truncate, schema).',
    allowManualDescription: true,
    parameters: {
      operation: {
        toolParamName: 'operation',
        description: 'The database operation to perform: executeQuery, insert, update, delete, createTable, bulkInsert, dropTable, truncateTable, tableExists, or getTableSchema',
        required: true,
        type: 'string',
      },
      query: {
        toolParamName: 'query',
        description: 'The SQL query to execute (for executeQuery operation)',
        required: false,
        type: 'string',
      },
      table: {
        toolParamName: 'table',
        description: 'The table name for table operations',
        required: false,
        type: 'string',
      },
      sourceArray: {
        toolParamName: 'sourceArray',
        description: 'Source array data for createTable or bulkInsert operations',
        required: false,
        type: 'array',
      },
      updateKey: {
        toolParamName: 'update_key',
        description: 'The column to use as the key for UPDATE operations',
        required: false,
        type: 'string',
      },
      deleteKey: {
        toolParamName: 'delete_key',
        description: 'The column to use as the key for DELETE operations',
        required: false,
        type: 'string',
      },
    },
    outputMapping: {
      rows: 'The query result rows or affected data',
      rowCount: 'Number of rows affected or returned',
      success: 'Whether the operation completed successfully',
      exists: 'Whether the table exists (for tableExists operation)',
      schema: 'Table schema information (for getTableSchema operation)',
    },
  },
};

export default definition;
